import * as types from '../types/exhibition';
import axios from 'axios';

export const registerExhibitionStart = () => ({
    type: types.REGISTER_EXHIBITION_START
});

export const registerExhibitionSuccess = (payload) => ({
    type: types.REGISTER_EXHIBITION_SUCCESS,
    payload
});

export const registerExhibitionFail = (error) => ({
    type: types.REGISTER_EXHIBITION_FAIL,
    payload: error
});


export const resgisterExhibitionInitiate = (name, phonenumber, email, selected, amount) => {
    return function (dispatch) {
        dispatch(registerExhibitionStart())
        axios
            .post(`${process.env.REACT_APP_BASE_URL}exhibition`,
              {
                name,
                phonenumber,
                email,
                selected,
                amount
            }
            )
            .then((res) => {
                dispatch(registerExhibitionSuccess(res.data))
            })
            .catch((error) => dispatch(registerExhibitionFail(error.response.data.error[0].message)))
    }   
}
